import AddIcon from "@mui/icons-material/Add";
import { Box } from "@mui/material";
import CustomButton from "components/common/CustomButton";
import FileSearch from "components/fileStorage/FileSearch";
import type { TimezoneDisplayMode } from "features/integrationsBeta/timezoneDisplay";
import DateRangeSelect, {
  ALL_PRESETS,
  FILTER_FIELD_W,
  PAST_PRESETS,
} from "./DateRangeSelect";
import TimezoneDisplayToggle from "./TimezoneDisplayToggle";

export interface IntegrationsFilters {
  last_run_after?: string;
  last_run_before?: string;
  next_run_after?: string;
  next_run_before?: string;
}

interface Props {
  filters: IntegrationsFilters;
  onChange: (filters: IntegrationsFilters) => void;
  search: string;
  onSearch: (term: string | null) => void;
  timezoneMode: TimezoneDisplayMode;
  onTimezoneModeChange: (mode: TimezoneDisplayMode) => void;
  showRegister?: boolean;
  onRegister?: () => void;
}

export default function IntegrationsFilterBar({
  filters,
  onChange,
  search,
  onSearch,
  timezoneMode,
  onTimezoneModeChange,
  showRegister,
  onRegister,
}: Props) {
  const set = (patch: Partial<IntegrationsFilters>) =>
    onChange({ ...filters, ...patch });

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1.5,
        alignItems: "center",
      }}
    >
      <Box sx={{ width: FILTER_FIELD_W }}>
        <FileSearch
          onSearch={onSearch}
          label="Search"
          size="small"
          initialValue={search}
          fullWidth
        />
      </Box>

      <DateRangeSelect
        label="Last Run"
        presets={PAST_PRESETS}
        value={{
          after: filters.last_run_after,
          before: filters.last_run_before,
        }}
        onChange={(r) =>
          set({ last_run_after: r.after, last_run_before: r.before })
        }
      />
      <DateRangeSelect
        label="Next Run"
        presets={ALL_PRESETS}
        value={{
          after: filters.next_run_after,
          before: filters.next_run_before,
        }}
        onChange={(r) =>
          set({ next_run_after: r.after, next_run_before: r.before })
        }
      />

      <CustomButton fullWidth={false} onClick={() => onChange({})}>
        Clear Filters
      </CustomButton>

      <Box sx={{ flexGrow: 1 }} />

      <TimezoneDisplayToggle
        mode={timezoneMode}
        onChange={onTimezoneModeChange}
      />

      {showRegister && (
        <CustomButton
          fullWidth={false}
          startIcon={<AddIcon />}
          onClick={onRegister}
        >
          Register
        </CustomButton>
      )}
    </Box>
  );
}
